import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import React, { useEffect, useState } from "react";
import moment from "moment";
import { listServiceApi } from "../../../../services/Admin/service";
import useAuth from "../../../../hooks/useAuth";
import { getWorkerFilter } from "../../../../services/Admin/user";
import { checkWorkerApi } from "../../../../services/Admin/calendar";

const WARNING_LABELS = {
    inactive: "Dado de baja",
    outside_contract: "Fuera de su periodo de contrato",
    absence: "Ausencia / vacaciones",
    outside_availability: "Fuera de su franja de disponibilidad",
    overlap: "Ya tiene otro servicio asignado a esa hora",
    hours_exceeded: "Supera sus horas semanales contratadas",
    service_not_offered: "No tiene este servicio asignado",
    zone_mismatch: "Su zona habitual no coincide con la del cliente",
    not_found: "Trabajador no encontrado",
};

export default function Services(props) {

    const {
        formik,
        defaultServiceValueList,
        setDefaultServiceValueList,
        isClientSelect,
        defaultUserWorkerValueList,
        originalClient,
        setDefaultUserWorkerValueList,
        services,
        idTask,
        isNewTask,
        newDates,
        onAvailabilityBlockedChange,
    } = props

    const { auth } = useAuth()

    const [listService, setListService] = useState([])
    const [listUserWorker, setListUserWorker] = useState([])
    const [hideWorker, setHideWorker] = useState(true)

    const [availabilityWarnings, setAvailabilityWarnings] = useState([])
    const [forceAssign, setForceAssign] = useState(false)
    const [checkingAvailability, setCheckingAvailability] = useState(false)

    const role = auth ? auth.primaryUser.role : null
    const organizationId = auth ? auth?.primaryUser?.organizationId : null

    useEffect(() => {
        getServices()
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        // Mostramos los municipios que tiene disponibles el usuario
        if (formik.values.idRegion?.id && formik.values.idProvince?.id && formik.values.idMunicipality?.id && formik.values.idService) {
            getWorker()
        } else {
            setListUserWorker({})
            setHideWorker(false)
        }
    }, [formik.values]) // eslint-disable-line react-hooks/exhaustive-deps

    // Dia a comprobar: el del formulario (editar) o el primero elegido (crear).
    const checkDay = isNewTask
        ? (newDates && newDates[0] ? moment.unix(newDates[0].getTime() / 1000).format("YYYY-MM-DD") : null)
        : formik.values.date

    useEffect(() => {
        const idWorker = formik.values.idWorker
        const idService = formik.values.idService
        const startHour = formik.values.startHour
        const endHour = formik.values.endHour

        if (!idWorker || !idService || !startHour || !endHour || !checkDay) {
            setAvailabilityWarnings([])
            setForceAssign(false)
            return
        }

        const timeOutId = setTimeout(() => {
            const startTs = new Date(`${checkDay} ${startHour}`).getTime() / 1000
            const endTs = new Date(`${checkDay} ${endHour}`).getTime() / 1000

            setCheckingAvailability(true)
            checkWorkerApi({
                idWorker,
                idService,
                startHour: startTs,
                endHour: endTs,
                ...(formik.values.idClient ? { idClient: formik.values.idClient } : {}),
                ...(idTask ? { id: idTask } : {}),
            }).then(resp => {
                if (resp.data.status) {
                    setAvailabilityWarnings(resp.data.data.warnings || [])
                    setForceAssign(false)
                } else {
                    setAvailabilityWarnings([])
                }
            }).catch(err => {
                console.error(err)
                setAvailabilityWarnings([])
            }).finally(() => {
                setCheckingAvailability(false)
            })
        }, 500)

        return () => clearTimeout(timeOutId)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formik.values.idWorker, formik.values.idService, formik.values.idClient, formik.values.startHour, formik.values.endHour, checkDay, idTask])

    useEffect(() => {
        if (onAvailabilityBlockedChange) {
            onAvailabilityBlockedChange(availabilityWarnings.length > 0 && !forceAssign)
        }
    }, [availabilityWarnings, forceAssign, onAvailabilityBlockedChange])

    const getWorker = async () => {
        getWorkerFilter({
            idRegion: formik.values.idRegion?.id,
            idProvince: formik.values.idProvince?.id,
            idMunicipality: formik.values.idMunicipality?.id,
            idService: formik.values.idService
        }).then(resp => {
            if (resp.data.status) {
                const temp = resp.data.data.map((doc) => {
                    return {
                        ...doc,
                    }
                })
                setListUserWorker(temp)
            }
            setHideWorker(true)
        })
    }

    const getServices = async () => {

        listServiceApi().then(resp => {
            const temp = resp.data.data.map((doc) => {
                return {
                    id: doc.id,
                    ...doc,
                }
            })
            setListService(temp)
        }).catch(err => {
            console.error(err)
        })
    }

    const onChangeService = (event, value) => {
        if (value) {
            formik.setFieldValue("idService", value ? Number(value.id) : null);
            setDefaultServiceValueList({
                id: value.id,
                name: value.name,
            });

            // Buscar el pvp en la estructura nueva de services o en listService
            let pvp = "";
            let serviceType = null;

            if (services && Array.isArray(services)) {
                // El formato es: [{ "12": [ { id: 24, pvp: "1.00" }, ... ] }]
                const org = services.find(org => org[organizationId]);
                const orgServicesArr = org ? org[organizationId] : null;

                if (orgServicesArr && Array.isArray(orgServicesArr)) {
                    const serv = orgServicesArr.find(s => `${s.id}` === `${value.id}`);
                    if (serv) {
                        pvp = serv.pvp || serv.defaultPvp || "";
                        serviceType = serv.serviceType || null;
                    }
                }
            }

            // Si no se encontró pvp en services, buscar en listService
            if (!pvp && Array.isArray(listService)) {
                const serviceFromList = listService.find(s => `${s.id}` === `${value.id}`);
                if (serviceFromList && serviceFromList.pvp) {
                    pvp = serviceFromList.pvp;
                }
            }

            formik.setFieldValue("price", pvp);
            formik.setFieldValue("serviceType", serviceType);
        } else {
            formik.setFieldValue("idService", null);
            formik.setFieldValue("price", "");
            formik.setFieldValue("serviceType", null);
            setDefaultServiceValueList({});
        }

        formik.setFieldValue("idWorker", null);
        setDefaultUserWorkerValueList({});
    };

    // ### CHANGE
    const changeWorker = (event, value) => {
    if (value !== null) {
        formik.setFieldValue("idWorker", value.id ? Number(value.id) : null);

        setDefaultUserWorkerValueList({
        id: value.id,
        name: value.name,
        surnames: value.surnames,
        email: value.email,
        isActive: value.isActive,
        });
    } else {
        formik.setFieldValue("idWorker", null);
        setDefaultUserWorkerValueList({});
    }
    };

    return (
        <Box border={1} className="p-20 mt-2 box-default">
            <Grid container spacing={2}>
                <Grid item md={12}>
                    <h5 className="p-0 mt-0">Servicio / Trabajador</h5>
                </Grid>
                <Grid item md={12}>
                    <Autocomplete
                        name="idServiceList"
                        getOptionSelected={(option, value) => option.value === value.value}
                        onChange={onChangeService}
                        options={listService}
                        value={defaultServiceValueList}
                        getOptionLabel={(option) => option.name || ""}
                        fullWidth
                        size="small"
                        disabled={!isClientSelect}
                        renderInput={(params) => <TextField
                            {...params}
                            label="* Servicio"
                            variant="outlined"
                            name="idService"
                            InputLabelProps={{ shrink: true }}
                        />}
                    />
                </Grid>
                {role === "ROLE_ADMIN" && (
                    <>
                        <Grid item md={12}>
                            <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
                                <div style={{
                                    background: "#f5f5f5",
                                    padding: "8px 16px",
                                    borderRadius: "6px",
                                    minWidth: "180px",
                                    display: "flex",
                                    alignItems: "center",
                                    marginTop: "-10px"
                                }}>
                                    <span style={{ fontWeight: 500 }}>Precio Fijo: </span>
                                    <strong style={{ marginLeft: "8px" }}>
                                        {originalClient?.precioFijo ? "Sí" : "No"}
                                    </strong>
                                </div>
                                <TextField
                                    variant="outlined"
                                    label="* Precio"
                                    disabled={!isClientSelect}
                                    className="form-control"
                                    name="price"
                                    type="text"
                                    size="small"
                                    value={formik.values.price}
                                    onChange={formik.handleChange}
                                    InputLabelProps={{ shrink: true }}
                                    fullWidth
                                    style={{ maxWidth: "330px" }}
                                />
                            </div>
                        </Grid>
                    </>
                )}

                {formik.values.serviceType === "KEY_UNIT" ? (
                    <Grid item md={12}>
                        <TextField
                            name="serviceUnit"
                            label="Unidades de servicio"
                            multiline
                            variant="outlined"
                            fullWidth
                            size="small"
                            value={formik.values.serviceUnit || 1}
                            onChange={formik.handleChange}
                            InputLabelProps={{ shrink: true }}
                        />
                    </Grid>
                ) : null}

                <Grid item md={12}>
                    <TextField
                        disabled={!isClientSelect}
                        name="observaciones"
                        label="Observaciones de la tarea"
                        multiline
                        rows={6}
                        variant="outlined"
                        fullWidth
                        size="small"
                        value={formik.values.observaciones}
                        onChange={formik.handleChange}
                        InputLabelProps={{ shrink: true }}
                    />
                </Grid>

                <Grid item md={12}>
                    <Autocomplete
                        options={listUserWorker}
                        value={defaultUserWorkerValueList}
                        getOptionLabel={(option) => {
                            if (Object.keys(option).length !== 0) {
                                if (!option.isActive) {
                                    return `${option.name} ${option.surnames} - ${option.email} - (Inactivo)`
                                } else {
                                    return `${option.name} ${option.surnames} - ${option.email} `
                                }

                            } else {
                                return ""
                            }
                        }}
                        getOptionSelected={(option, value) =>
                            option.value === value.value
                        }
                        onChange={changeWorker}
                        disabled={!hideWorker}
                        fullWidth
                        size="small"
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="* Trabajador"
                                variant="outlined"
                                name="idWorker"
                                InputLabelProps={{ shrink: true }}
                            />
                        )}
                    />
                </Grid>

                {checkingAvailability && (
                    <Grid item md={12}>
                        <p className="text-100">Comprobando disponibilidad del trabajador...</p>
                    </Grid>
                )}

                {!checkingAvailability && availabilityWarnings.length > 0 && (
                    <Grid item md={12}>
                        <Box className="alert-danger">
                            <strong>Este trabajador tiene avisos para ese horario:</strong>
                            <ul style={{ margin: "8px 0", paddingLeft: "20px" }}>
                                {availabilityWarnings.map((warning, index) => (
                                    <li key={index}>
                                        <strong>{WARNING_LABELS[warning.code] || "Aviso"}:</strong> {warning.message}
                                    </li>
                                ))}
                            </ul>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={forceAssign}
                                        onChange={(e) => setForceAssign(e.target.checked)}
                                    />
                                }
                                label="Asignar a este trabajador igualmente"
                            />
                        </Box>
                    </Grid>
                )}
            </Grid>
        </Box>
    )
}
